import React from 'react'
import { Box } from '@ztechapps/webui.util'
import { Col, Container, Row } from 'react-bootstrap'

export const AccountRegisterContainer = ({ children }) => {
  return (
    <Container className="py-5">
      <Row>
        <Col md={6} sm={12}>
          <Box>
            <Box.Body>{children}</Box.Body>
          </Box>
        </Col>
      </Row>
    </Container>
  )
}
